import styled from "styled-components";

interface StickBottomContainerProps {
	bgColor: string;
}

export const StickBottomContainer = styled.div`
	display: flex;
	position: fixed;
	width: 100%;
	height: 3.0625rem;
	box-shadow: 0px 2px 4px 0px rgba(#000000, 0.1);
	bottom: 0;
	left: 0;
	right: 0;
	justify-content: space-evenly;
	align-items: center;
	z-index: 10;
	background-color: ${(props: StickBottomContainerProps) =>
		props.bgColor ? props.bgColor : "#fff"};
	img {
		width: 2.5rem;
	}
	/* 兼容iponeX */
	@supports (bottom: constant(safe-area-inset-bottom)) {
		height: calc(3.0625rem + constant(safe-area-inset-bottom));
		padding-bottom: constant(safe-area-inset-bottom);
	}

	@supports (bottom: env(safe-area-inset-bottom)) {
		height: calc(3.0625rem + env(safe-area-inset-bottom));
		padding-bottom: env(safe-area-inset-bottom);
	}
`;
